import { useAuth, useUser } from "@clerk/clerk-expo";
import { useToken } from "@gluestack-style/react";
import Breadcrumbs from "components/general/Breadcrumbs";
import Container from "components/general/Container";
import { Box, Button, FormattedCurrency, H1, HStack, Link, ParagraphSmall, ScrollView, Text } from "components/ui";
import { useLocalSearchParams, usePathname } from "expo-router";
import { ChevronDown, ListChecks, MapPin, Scan, Settings, Truck } from "lucide-react-native";
import React from "react";
import { useGetOrderQuery, useGetSitesByIdQuery } from "store/abcoApi";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { SiteSelectButton } from "components/general/SiteSelectButton";
import { Value } from "types/select.types";
import { truncateText } from "utils/globalFunctions";
import Seo from "components/general/Seo";
type Props = {};

const SitesHeader = ({}: Props) => {
	const { id } = useLocalSearchParams<{ id: string }>();

	const { data: notSent } = useGetOrderQuery({
		pageSize: 1,
		pageNumber: 1,
		statusCollection: ["Not Sent"],
		siteIdCollection: [Number(id)],
	});
	const { data: approvals } = useGetOrderQuery({
		pageSize: 1,
		pageNumber: 1,
		statusCollection: ["Awaiting Approval"],
		siteIdCollection: [Number(id)],
	});

	const path = usePathname();
	const resolvedPrimarylightBlue = useToken("colors", "primarylightblue");
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const { data, isLoading, isFetching } = useGetSitesByIdQuery({
		id: Number(id),
	});
	const isMobile = useIsMobile();

	const TabCollection = [
		{ title: "Catalogue", path: "", notificationCount: 0 },
		{ title: "Orders", path: "/orders", notificationCount: approvals?.metaData?.total + notSent?.metaData?.total },
		//{ title: "Checklists", path: "/checklists", notificationCount: 2 },
		//{ title: "Support", path: "/support", notificationCount: 2 },
		//{ title: "Feedback", path: "/feedback", notificationCount: 2 },
		{ title: "Safety", path: "/safety" },
		{ title: "Equipment", path: "/equipment" },
	];

	const tabWidth = (100 / TabCollection.length + "%") as string;
	let currentBudget = 938;
	let totalBudget = 3000;
	var { user } = useUser();
	var isSuperAdmin = false;
	if (user && user.publicMetadata && user.publicMetadata.isSuperAdmin) {
		isSuperAdmin = true;
	}

	const percentageWidth = (currentBudget / totalBudget) * 100;

	return (
		<>
			{/* <Text>Address1: {data?.addressLine1} </Text>
			<Text>Address2: {data?.addressLine2} </Text>

			<Text>Address3: {data?.addressLine3} </Text>

			<Text>Name: {data?.name} </Text>

			<Text>postcode: {data?.postcode} </Text>

			<Text>state: {data?.state} </Text>
			<Text>suburb: {data?.suburb} </Text> */}
			<Box>
				<Container>
					<Seo title={data?.name + " | Abco"} description={""} />
					<Box paddingHorizontal={16} gap={isMobile ? 0 : 0}>
						<Box marginTop={isMobile ? 12 : 0} paddingVertical={16}>
							<Breadcrumbs idReplacement={data?.name} />
						</Box>
						<Box>
							<Box flexDirection={isMobile ? "column" : "row"}>
								<HStack alignItems="center" gap={12}>
									<MapPin color={resolvedPrimarylightBlue} width={40} height={isMobile ? 70 : 120} />

									<H1> {truncateText(data?.name || "", 35)}</H1>
								</HStack>
								<HStack alignItems="center" marginLeft={isMobile ? 0 : "auto"} gap={16}>
									{/* <Box flex={isMobile ? 1 : undefined}>
										<Button width={"$full"} borderRadius={12} gap={4} borderColor="transparent" variant="outline" bg="$primarylight" size="md">
											<ListChecks color="#ffffff" />
											<ParagraphSmall
												sx={{
													color: "$basicwhite",
												}}
											>
												Run on checklist
											</ParagraphSmall>
										</Button>
									</Box> */}
									{isSuperAdmin && (
										<Box flex={isMobile ? 1 : undefined}>
											<Button isLink href={"/admin"} borderRadius={12} gap={4} borderColor="$primarylight" variant="outline">
												<Settings color={resolvedPrimarylight} />
												<ParagraphSmall
													sx={{
														color: "$primarylight",
													}}
												>
													Admin
												</ParagraphSmall>
											</Button>
										</Box>
									)}
								</HStack>
							</Box>
						</Box>
					</Box>
				</Container>
				<Box bg="$neutral25">
					<Container>
						<Box paddingVertical={40}>
							<Box paddingHorizontal={isMobile ? 16 : 0} gap={16} justifyContent="space-between" flexDirection={isMobile ? "column" : "row"}>
								<Box
									sx={{
										shadowColor: "#000",
										shadowOffset: {
											width: 0,
											height: 1,
										},
										shadowOpacity: 0.18,
										shadowRadius: 1.0,

										elevation: 1,
									}}
									bg="$basicwhite"
									borderRadius={12}
									flexDirection="row"
								>
									<Box flexDirection={isMobile ? "column" : "row"} alignItems="center" justifyContent="space-between">
										<Box width={300} paddingBottom={isMobile ? 12 : 0} paddingHorizontal={isMobile ? 24 : 8} marginLeft={"auto"}>
											<HStack gap={12} alignItems="center">
												<Truck style={{ marginLeft: 12 }} />
												<Text>{data?.addressLine1}</Text>
											</HStack>
										</Box>
									</Box>

									<Box marginLeft={"auto"} position="relative" borderLeftWidth={1} borderColor="$neutral200" justifyContent="center" padding={20}>
										<Box borderWidth={1} borderColor="$neutral200" bg="$basicwhite" padding={4} borderRadius={"$full"} top={-8} right={-8} position="absolute">
											<Scan width={16} height={16} />
										</Box>
										<MapPin color={"black"} width={28} height={28} />
									</Box>
								</Box>
								{/* <Box width={"$full"} maxWidth={isMobile ? "auto" : 312}>
									<Box
										sx={{
											shadowColor: "#000",
											shadowOffset: {
												width: 0,
												height: 1,
											},
											shadowOpacity: 0.18,
											shadowRadius: 1.0,

											elevation: 1,
										}}
										borderRadius={12}
										paddingVertical={12}
										paddingHorizontal={16}
										position="relative"
										bg="$basicwhite"
									>
										<HStack justifyContent="space-between" w="$full" gap={38}>
											<FormattedCurrency sx={{ fontWeight: "bold" }} amount={938} />
											<Box flexDirection="row" gap={8}>
												<FormattedCurrency sx={{ fontWeight: "bold" }} amount={3000} />
												<Text>(Budget)</Text>
											</Box>
										</HStack>
										<Box w="$full" marginVertical={8} flexDirection="row" borderRadius={16} overflow="hidden" h={12} backgroundColor="$neutral100">
											<Box
												h={12}
												sx={{
													width: `${percentageWidth}%`,
													bgColor: "$primarylightblue",
												}}
											></Box>
										</Box>
										<Box borderWidth={1} borderColor="$neutral200" bg="$basicwhite" padding={4} borderRadius={"$full"} top={-8} right={-8} position="absolute">
											<Scan width={16} height={16} />
										</Box>
									</Box>
								</Box> */}
							</Box>
						</Box>
					</Container>
					<Box>
						<Container>
							<HStack alignContent="center" justifyContent="space-around" w="100%" px={6} role="navigation" sx={{ borderBottomColor: "$neutral100", borderBottomWidth: 1 }}>
								{isMobile && (
									<ScrollView horizontal={true} showsHorizontalScrollIndicator={false} contentContainerStyle={{ flexGrow: 1 }}>
										{TabCollection.map((child: any, index: number) => {
											const isActiveTab = child.path === "" ? path === `/sites/${id}` : path.includes(child.path);
											const textColour = isActiveTab ? "$primarylight" : "$neutral600";
											const fontWeight = isActiveTab ? 700 : 400;
											const borderBottom = isActiveTab ? 2 : 0;

											return (
												<Link key={index} href={`/sites/${id}${child.path}`} width={tabWidth}>
													<Box
														sx={{
															backgroundColor: "$basicwhite",
															padding: 10,
															marginRight: 10,
															borderBottomColor: "$primarylight",
															borderBottomWidth: borderBottom,
														}}
														position="relative"
													>
														<HStack paddingHorizontal={8} gap={8} alignItems="center" justifyContent="center">
															<Text sx={{ color: textColour, fontWeight: fontWeight, textAlign: "center" }}>{child.title}</Text>
															{child.notificationCount > 0 && (
																<Box justifyContent="center" alignItems="center" bg="$errormain" width={24} height={24} borderRadius={"$full"}>
																	<Text color="$basicwhite">{child.notificationCount}</Text>
																</Box>
															)}
														</HStack>
													</Box>
												</Link>
											);
										})}
									</ScrollView>
								)}
								{!isMobile &&
									TabCollection.map((child: any, index: number) => {
										const isActiveTab = child.path === "" ? path === `/sites/${id}` : path.includes(child.path);
										const textColour = isActiveTab ? "$primarylight" : "$neutral600";
										const fontWeight = isActiveTab ? 700 : 400;
										const borderBottom = isActiveTab ? 2 : 0;

										return (
											<Link key={index} href={`/sites/${id}${child.path}`} width={tabWidth}>
												<Box
													sx={{
														backgroundColor: "$basicwhite",
														padding: 10,
														marginRight: 10,
														borderBottomColor: "$primarylight",
														borderBottomWidth: borderBottom,
													}}
													position="relative"
												>
													<HStack gap={8} alignItems="center" justifyContent="center">
														<Text sx={{ color: textColour, fontWeight: fontWeight, textAlign: "center" }}>{child.title}</Text>
														{child.notificationCount > 0 && (
															<Box justifyContent="center" alignItems="center" bg="$errormain" width={24} height={24} borderRadius={"$full"}>
																<Text color="$basicwhite">{child.notificationCount}</Text>
															</Box>
														)}
													</HStack>
												</Box>
											</Link>
										);
									})}
							</HStack>
						</Container>
					</Box>
				</Box>
			</Box>
		</>
	);
};

export default SitesHeader;
